export let lang = {
  'id': 'en',
  // Errors
  'errorBaseConfigurationNotLoaded': 'Could not load base configuration',
  'errorExhibitionSpecificConfiguration': 'Could not load fair-specific configuration',
  'errorNoBoothId': 'No booth ID specified',
  'errorNoBoothForBoothId': 'The system could not find a booth for the given booth ID',
  'errorNoValidConfiguration': 'No valid configuration found for the selected trade fair',
  'errorGivenExhibitionIdNotFound': 'Could not find the given fair ID',
  'errorNoExhibitionIdsInConfig': 'The configuration does not contain any trade fair IDs',
  'errorInitFailedNoValidExhibitionId': 'Cannot initialize map. No valid fair ID found',
  'errorInvalidHash': 'The specified hash value is invalid',
  'errorTitle': 'Flayr Error',
  'errorUnknownLayerFormat': 'is an unknown layer format',
  'errorUnknownSourceTypeForLayers': 'is an unknown source type for layers',
  'errorUnknownLayerType': 'is an unknown layer type',
  'errorUnknownSourceType': 'is an unknown source type',
  // Buttons
  'buttonBackToBooth': 'Back to booth',
  'buttonAlternativePlacementProposal': 'Alternative placement proposal:',
  'buttonPrintHallPlan': 'Print hall plan',
  // Navigator
  'navigatorYouAreHere': 'You are here: ',
  'navigatorPlaceholder': 'Exhibition Site',
  // Side navigation / Attribution
  'sideNavigationImprint': 'Imprint',
  'sideNavigationDataPrivacy': 'Privacy Policy',
  'sideNavigationTermsAndConditions': 'Terms and Conditions',
  'sideNavigationHelp': 'Help',
  // Print
  'printPoweredBy': 'Powered by Flayr',
  'printPrintHeader': 'Booth Placement Proposal',
  'printProposedBooth': 'Proposed Booth:',
  'printExhibitorName': 'Exhibitor name:',
  'printBillingAddress': 'Billing address:',
  'printExhibitorType': 'Exhibitor type:',
  'printOtherExhibitors': 'Other exhibitors at your booth:',
  'printDateTime': 'of {DATE}, {HOUR}:{MINUTE} o\'clock',
  // Context
  'contextOverview': 'Overview',
  'contextBooth': 'Booth',
  'contextLoadingData': 'Loading data',
  'contextExhibitor': 'Exhibitor',
  'contextExhibitorIcon': 'fa-user',
  'contextCoexhibitor': 'Co-exhibitor',
  'contextCoexhibitorIcon': 'fa-user',
  'contextJointExhibitor': 'Joint Exhibitor',
  'contextJointExhibitorIcon': 'fa-users',
  'contextJointOrganiser': 'Joint Organiser',
  'contextJointOrganiserIcon': 'fa-users',
  'contextBoothDimensions': 'Booth dimensions',
  'contextBoothWidth': 'Width:',
  'contextBoothDepth': 'Depth:',
  'contextBoothArea': 'Area:',
  'contextMoreDetails': 'More details about',
  'contextMoreDetailsLinkTitle': 'Click here to learn more about {FEATURE}',
  // JSON
  'jsonHall': 'Hall',
  'OUTDOORSPACE': 'Outdoor Area',
  'YARD': 'Yard',
  'jsonEntry': 'Entry',
  'ICM': 'ICM',
  'ATRIUM': 'Atrium',
  'GATE': 'Gate',
  'MENSWC': 'Men\'s WC',
  'LADIESWC': 'Ladies WC',
  'DISABLEDPWC': 'WC for disabled persons',
  'BISTRO': 'Bistro',
  'RESTAURANTKAEFER': 'Restaurant "Käfer am See" on the upper floor',
  'KAEFERDAYBAR': 'Käfer Day Bar',
  'INFOBOOTH': 'Information booth',
  'ROLLUPDOOR': 'Roll-up door',
  'PRCARPARK': 'P + R car park',
  'NORTH': 'North',
  'NORTHEG': 'North Ground Floor',
  'NORTHOG': 'North Upper Floor',
  'EAST': 'East',
  'EASTEG': 'East Ground Floor',
  'EASTOG': 'East Upper Floor',
  'WEST': 'West',
  'WESTEG': 'West Ground Floor',
  'WESTOG': 'West Upper Floor',
  'CHANNEL': 'Channel',
  'CHANNELEAST': 'Channel East',
  'CONFERENCEROOM': 'Conference Room',
  'FOYER': 'Lobby',
  'ICMBUSINESSCENTER': 'ICM Business Center',
  'SALOON': 'Saloon',
  'GASTRONOMYCATERING': 'Gastronomy / Catering',
  'TICKETS': 'Tickets',
  'AMBULANCE': 'Ambulance',
  'SNACKBAR': 'Snack Bar',
  'CCN': 'CCN',
  'PIZZASERVICEMARCO': '(Pizza) Service Marco',
  // Tooltip
  'tooltipBooth': 'Booth',
  // Modules
  'rotateControlNorthRotationTitle': 'Align north',
  'rotateControlRotateLeftTitle': 'Rotate left',
  'rotateControlRotateRightTitle': 'Rotate right',
  'rotateControlResetRotationTitle': 'Reset to initial rotation',
  'sideNavigationDefaultTitle': 'Main Menu',
  'SOLD': 'SOLD',
  'FREE': 'AVAILABLE',
  'HALLSOLDOUT': 'SOLD OUT',
};
